//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { memo } from "react";
import { AlertTriangle, X } from "lucide-react";

const ConfirmModal = memo<{
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
}>(
  ({
    isOpen,
    onConfirm,
    onCancel,
    title = "Confirm Action",
    message = "Are you sure?",
  }) => {
    if (!isOpen) return null;

    return (
      <div
        className={tw`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50`}
        onClick={onCancel}
      >
        <div
          className={tw`bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={tw`flex items-center gap-3 p-6 border-b`}>
            <div
              className={tw`flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center`}
            >
              <AlertTriangle className={tw`text-red-600`} size={20} />
            </div>
            <h3 className={tw`text-lg font-semibold text-gray-900`}>{title}</h3>
          </div>

          <div className={tw`p-6`}>
            <p className={tw`text-gray-600 text-sm leading-relaxed`}>
              {message}
            </p>
          </div>

          <div
            className={tw`flex items-center justify-end gap-3 p-6 bg-gray-50 border-t`}
          >
            <button
              onClick={onCancel}
              className={tw`px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors`}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={tw`px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors`}
            >
              Clear Reply
            </button>
          </div>
        </div>
      </div>
    );
  }
);

ConfirmModal.displayName = "ConfirmModal";

export { ConfirmModal };